import React, { Component } from 'react'
import PropTypes from 'prop-types'
import filtersHoc from './index'
import ProgressDialog from 'components/custom/ProgressDialog/index'

export default filtersHoc(ProgressDialog)
